import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export interface ApiStorageService {
  AccountId: string;
  Created: string;
  Information: any;
  Modified: string;
  Name: string;
  Notified: OnsipAPIBoolean;
  OrganizationId: string;
  Service: string;
  StorageServiceId: string;
}

export interface StorageService {
  accountId: string;
  created: string;
  information: any;
  awsAccessKey: string;
  awsSecretKey: string;
  awsBucketName: string;
  gCloudProjectId: string;
  gCloudClientEmail: string;
  gCloudPrivateKey: string;
  gCloudBucketName: string;
  rackspaceUsername: string;
  rackspaceApiKey: string;
  rackspaceContainerName: string;
  modified: string;
  name: string;
  notified: boolean;
  organizationId: string;
  service: string;
  storageServiceId: string;
  awsCustomUrl: string;
}

export function apiStorageServiceToStorageService(
  apiStorageService: ApiStorageService
): StorageService {
  return {
    accountId: apiStorageService.AccountId,
    created: apiStorageService.Created,
    information: apiStorageService.Information,
    awsAccessKey: apiStorageService.Information.AwsAccessKey || "",
    awsSecretKey: apiStorageService.Information.AwsSecretKey || "",
    awsBucketName: apiStorageService.Information.AwsBucketName || "",
    gCloudProjectId: apiStorageService.Information.GCloudProjectId || "",
    gCloudClientEmail: apiStorageService.Information.GCloudClientEmail || "",
    gCloudPrivateKey: apiStorageService.Information.GCloudPrivateKey || "",
    gCloudBucketName: apiStorageService.Information.GCloudBucketName || "",
    rackspaceUsername: apiStorageService.Information.RackspaceUsername || "",
    rackspaceApiKey: apiStorageService.Information.RackspaceApiKey || "",
    rackspaceContainerName: apiStorageService.Information.RackspaceContainerName || "",
    modified: apiStorageService.Modified,
    name: apiStorageService.Name,
    notified: onsipApiBooleanToBoolean(apiStorageService.Notified),
    organizationId: apiStorageService.OrganizationId,
    service: apiStorageService.Service,
    storageServiceId: apiStorageService.StorageServiceId,
    awsCustomUrl: apiStorageService.Information.AwsCustomUrl || ""
  };
}
